import { httpClient } from '@/utils/http-client';
export default class RestService {
    uri = null;
    client = httpClient;
    async fetch() {
        return await (await httpClient.get('/')).data;
    }
    async duplicate(draftid) {
        return (await httpClient.get(`${this.uri}/duplicate-project/${draftid}`)).data;
    }
    async create(createDto, optionalRequestArgs) {
        return (await httpClient.post(`${this.uri}`, createDto, optionalRequestArgs)).data;
    }
    async fetchSingle(id, optionalRequestArgs) {
        return (await httpClient.get(`${this.uri}/${id}`, optionalRequestArgs)).data;
    }
    async fetchAll(optionalRequestArgs) {
        return (await httpClient.get(`${this.uri}`, optionalRequestArgs)).data;
    }
    async update(id, data, optionalRequestArgs) {
        return (await httpClient.patch(`${this.uri}/${id}`, data, optionalRequestArgs)).data;
    }
    async delete(id, optionalRequestArgs) {
        return (await httpClient.delete(`${this.uri}/${id}`, optionalRequestArgs)).data;
    }
}
